const IncomeDistributionGraph = ({locationStatistics}) => {
    return (
        <>
            {locationStatistics.isDisplayableIncomeDistributionGraph &&
                <div className="p-chart_wrap">
                    <div className="p-chart_value_upper">
                        <p className="p-chart_value"><span
                            className="p-chart_value_unit">$</span><span
                            className="p-chart_value_data">{locationStatistics.knowledgePanelStatistics?.medianSalary}</span></p>
                        <p className="p-chart_value_index">Median Annual Earnings</p>
                    </div>
                    <div className="p-chart_line_wrap">
                        <canvas id="chartjs_earnings"
                                className="p-chart_line s-chart_line s-chart_line--earnings"
                                height="100"
                                data-chart="earnings"></canvas>
                        <ul className="p-chart_label">
                            <li className="p-chart_label_item">- $9,999</li>
                            <li className="p-chart_label_item">$100,000 -</li>
                        </ul>
                    </div>
                    <div className="p-chart_value_bottom">
                        <p className="p-chart_value_txt">* Full-Time Workers in {locationStatistics.knowledgePanelStatistics?.yearlyObservationYear}</p>
                    </div>
                </div>
            }
        </>
    )
}

export default IncomeDistributionGraph;
